import type {
  AgentDeployWhatsapp,
  AgentDeployWhatsappBody,
} from "@/schemas/agent-deploy-whatsapp.schema";
import type { WhatsappOutbound, WhatsAppTemplate } from "@/schemas/whatsapp.schema";
import { api } from "@/services/api";

export const agentDeployWhatsappApi = {
  async create(body: AgentDeployWhatsappBody) {
    const { data } = await api.post<AgentDeployWhatsapp>("/agent-deploy-whatsapp", body);

    return data;
  },

  async activate(id: string) {
    await api.post(`/agent-deploy-whatsapp/${id}/activate`);
  },

  async deactivate(id: string) {
    await api.post(`/agent-deploy-whatsapp/${id}/deactivate`);
  },

  async updateConfigurationById(
    id: string,
    configuration: AgentDeployWhatsappBody["configuration"]
  ) {
    await api.patch<AgentDeployWhatsapp>(
      `/agent-deploy-whatsapp/${id}/configuration`,
      configuration
    );
  },

  async registerNumber(agentId: string, body: { phone_number_id: string; pin: string }) {
    const { data } = await api.post<{ success: boolean }>(
      `/agent-deploy-whatsapp/${agentId}/register-number`,
      body
    );

    return data;
  },

  async removeById(id: string) {
    await api.delete(`/agent-deploy-whatsapp/${id}`);
  },

  async getTemplates(id: string): Promise<WhatsAppTemplate[]> {
    const { data } = await api.get<WhatsAppTemplate[]>(`/agent-deploy-whatsapp/${id}/templates`);

    return data;
  },

  async sendMessage(id: string, body: WhatsappOutbound) {
    await api.post(`/agent-deploy-whatsapp/${id}/send-message`, body);
  },
};
